import { fork, take, put } from 'redux-saga/effects';
import cloneDeep from 'lodash/cloneDeep';
import noop from 'lodash/noop';

import {
  CONFIRM_ACTION_ASK_CONFIRM_ACTION,
  CONFIRM_ACTION_CANCEL_ACTION,
  CONFIRM_ACTION_CONFIRM_ACTION,
} from '../actions/confirm-action/constants';
import * as actConfirmAction from '../actions/confirm-action';

/** **************************************************************************************************
 * Action Confirmation
 *************************************************************************************************** */

export function* askConfirmActionFlow() {
  // noinspection InfiniteLoopJS
  while (true) {
    const {
      payload: { nextAction, customText, callback },
    } = yield take(CONFIRM_ACTION_ASK_CONFIRM_ACTION);
    // set location and show modal
    yield put(actConfirmAction.setNextAction(nextAction));
    yield put(actConfirmAction.showConfirmActionModal(customText));
    yield put(actConfirmAction.setCallback(callback));
  }
}

export function* confirmActionFlow() {
  // noinspection InfiniteLoopJS
  while (true) {
    const {
      payload: { nextAction },
    } = yield take(CONFIRM_ACTION_CONFIRM_ACTION);
    // clear location, hide modal, and run the action
    yield put(actConfirmAction.setNextAction(null));
    yield put(actConfirmAction.hideConfirmActionModal());
    yield put(actConfirmAction.setCallback(noop));
    yield put(cloneDeep(nextAction));
  }
}

export function* cancelActionFlow() {
  // noinspection InfiniteLoopJS
  while (true) {
    yield take(CONFIRM_ACTION_CANCEL_ACTION);
    // clear location and hide modal
    yield put(actConfirmAction.setNextAction(null));
    yield put(actConfirmAction.hideConfirmActionModal());
    yield put(actConfirmAction.setCallback(noop));
  }
}

/** **************************************************************************************************
 * End Action Confirmation
 *************************************************************************************************** */

export default function* confirmActionSaga() {
  yield fork(askConfirmActionFlow);
  yield fork(confirmActionFlow);
  yield fork(cancelActionFlow);
}
